export default __webpack_public_path__ + "static/media/img-bug-bounty-eligible.36355fe2.png";